<!--スケジュール-->
<!--tab2配置表示-->
<template>
  <div style="border: 0px solid red; height:100%" class="i0020Class">
    <!-- 年月 -->
    <el-row type="flex" align="bottom">
      <el-col :span="9" align="middle">
        <span>{{selectedMonthStr}}</span>
      </el-col>
      <el-col :span="14" align="right" style="font-size: 0">
        <el-button style="background-color: #f7fbfc;margin-left:0px;border-radius:0px" size="small" @click.native="preMonthClick">{{$t('MODULE.S0001_LBL_PREMONTH')}}</el-button>
        <el-button style="background-color: #f7fbfc;margin-left:0px;border-radius:0px" size="small" @click.native="todayClick">{{$t('MODULE.S0001_LBL_TODAY')}}</el-button>
        <el-button style="background-color: #f7fbfc;margin-left:0px;border-radius:0px" size="small" @click.native="nextMonthClick">{{$t('MODULE.S0001_LBL_NEXTMONTH')}}</el-button>
      </el-col>
    </el-row>
    <el-row class="calenderMode1-calendar" style="text-align:center;margin-top: 2px;">
      <div style="padding: 0px 0px 0px 0px; width: 100%;height: 100%;">
        <el-calendar :firstDayOfWeek="7" ref="elCalendar" v-model="showMonth">
          <template slot="dateCell" slot-scope="{date, data}">
            <div @touchstart="touchStart(data)" @touchend="touchEnd(data)" slot="reference" class="el-calendar-day">
              <div v-html="data.day.split('-')[2]" @click="dateCellClick(data)"></div>
              <div v-html="calendarCellcharacters(data)"></div>
            </div>
          </template>
        </el-calendar>
      </div>
    </el-row>
    <!-- 基本情報 -->
    <div v-show="showDetail" style="margin-top:5px">
      <!-- 表头文字 -->
      <el-row :gutter="0" style="background-color:#3cc6fa;">
        <div class="table-header">{{detailDate}}</div>
      </el-row>
      <table class="i0020-table table-label">
        <!-- 出勤可能時間帯 -->
        <tr>
          <td class="i0020-form-label">{{$t('MODULE.I0020_LBL_WORK_TIME')}}</td>
          <td class="i0020-form-value">
            <el-input :disabled="editChk" v-model="workDateStart" @input.native="workDateStart = timeInputCheck(workDateStart)" @change="workDateStart = cal1_inputBlur(workDateStart),cal2_inputBlur()" style="width:44%;" class="css-dialog-input-width" size="mini" clearable></el-input>
            ～<el-input :disabled="editChk" v-model="workDateEnd" @input.native="workDateEnd = timeInputCheck(workDateEnd)" @change="workDateEnd = cal1_inputBlur(workDateEnd),cal2_inputBlur()" style="width:44%;margin-left:4px;" class="css-dialog-input-width" size="mini" clearable></el-input>
          </td>
        </tr>
        <!-- 備考 -->
        <tr>
          <td class="i0020-form-label">{{$t('MODULE.I0018_LBL_COL15')}}</td>
          <td class="i0020-form-value">
            <el-input :disabled="noteChk" v-model="note" @change="changedCheck = true" @blur="cal2_inputBlur()" type="textarea" maxlength=500 :rows="3" class="input_textarea_i0020"></el-input>
          </td>
        </tr>
      </table>
    </div>
    <!-- 申请按钮 -->
    <div style="text-align:center">
      <el-button type="primary" v-show="isEditMode" class="css-btn css-button" style="margin-top: 8px;width:120px;" @click="save_btn()">{{$t('MODULE.K0011_LBL_MSG7')}}</el-button>
      <el-button type="primary" class="css-btn css-button" style="margin-top: 8px;width:120px;" @click="ret_click()">{{$t('MODULE.I0018_LBL_BTN2')}}</el-button>
    </div>
  </div>
</template>
<script>
import * as amsApi from "../api/i_0017"
import utilsApi from '../../common/utils'
let url = require('@/../config/sysConfig')
export default {
  data() {
    return {
      calenderDateList: [],//calender1表示用list
      selectedMonth: '',//当前月（字符串格式）
      selectedDay: '',//当前点击的日期（字符串格式）
      login_userCd: '',//登陆者cd
      icon_maru: '〇',
      icon_corss: '✖',
      weekStr: [],//一周的文言
      detailDate: '',
      detailDateChk: '',
      workDateStart: '',
      workDateEnd: '',
      note: '',
      showDetail: false,
      editChk: true,
      noteChk: true,
      longPress: false,
      touchmoveFlag: false,
      isEditMode: false,
      changedCheck: false,
      showMonth: new Date(this.$route.query.jobDate)
    };
  },
  mounted() {
    this.query()
  },
  created: function () {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.login_userCd = userInfo.userCd
    this.selectedMonth = this.$route.query.jobDate
  },
  methods: {
    // キャンセル
    ret_click() {
      this.$router.push({ path: url.routerUrl_I0019, query: { recruitNo: this.$route.query.recruitNo, fieldCd: this.$route.query.fieldCd, jobDate: this.$route.query.jobDate, editShow: this.$route.query.editShow } })
    },
    // 検索
    async query() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
      setTimeout(() => {
        loading.close()
      }, 2000)
      var yearMonth = this.selectedMonth.replaceAll('/', '').substring(0, 4) + '/' + this.selectedMonth.replaceAll('/', '').substring(4, 6)
      // 検索処理
      await amsApi.i_0017_apply_search(this.login_userCd, yearMonth, this.$route.query.fieldCd, this.$route.query.recruitNo).then(res => {
        //初始化前清空
        this.calenderDateList = undefined;
        this.calenderDateList = new Array();
        this.selectedDay = ''
        this.isEditMode = false
        this.showDetail = false
        this.changedCheck = false
        this.editChk = true
        this.noteChk = true
        if (res.code === 300) {
          loading.close()
          return
        } else {
          //更新基本list
          this.calenderDateList = JSON.parse(JSON.stringify(res.items.jobApplyInfoList));
          this.calenderDateList.forEach((item) => {
            item.changeData = false
          })
        }
        loading.close()
      })
      //カレンダーのセルセット
      let calendarThead = document.querySelector(
        ".i0020Class .el-calendar-table thead"
      );
      calendarThead.childNodes[0].style.color = "red"
      calendarThead.childNodes[6].style.color = "blue"
      this.weekStr[0] = this.$t('MODULE.S0001_LBL_CALENDAR_SUN')
      this.weekStr[1] = this.$t('MODULE.S0001_LBL_CALENDAR_MON')
      this.weekStr[2] = this.$t('MODULE.S0001_LBL_CALENDAR_TUE')
      this.weekStr[3] = this.$t('MODULE.S0001_LBL_CALENDAR_WED')
      this.weekStr[4] = this.$t('MODULE.S0001_LBL_CALENDAR_THU')
      this.weekStr[5] = this.$t('MODULE.S0001_LBL_CALENDAR_FRI')
      this.weekStr[6] = this.$t('MODULE.S0001_LBL_CALENDAR_SAT')
      for (var i = 0; i < 7; i++) {
        calendarThead.childNodes[i].innerHTML = this.weekStr[i]
      }
      let calendarTbody = document.querySelector(
        ".i0020Class .el-calendar-table tbody"
      );
      var calendarTbodyChildren = calendarTbody.children;
      var calendarTbodyChildrenChildren;
      var changeChk = false
      var secondChk = false
      var num = 0;
      for (var i = 0; i < calendarTbodyChildren.length; i++) {
        calendarTbodyChildrenChildren = calendarTbody.children[i].cells
        for (var count = 0; count < calendarTbodyChildrenChildren.length; count++) {
          num++
          var date = calendarTbodyChildrenChildren[count].innerText[0] + calendarTbodyChildrenChildren[count].innerText[1]
          if (date == this.calenderDateList[0].jobDate.substring(8, 10)) {
            changeChk = true
          }
          if (changeChk && !secondChk) {
            this.calenderDateList.forEach((item) => {
              if (item.jobDate) {
                if (date == item.jobDate.substring(8, 10)) {
                  if (item.applyStatus == '3') {
                    calendarTbodyChildrenChildren[count].style.background = "#DFEDF2"
                  } else if (item.applyStatus == '1' || item.applyStatus == '0') {
                    calendarTbodyChildrenChildren[count].style.background = "#F7FBFC"
                  } else if (item.applyStatus == '2') {
                    calendarTbodyChildrenChildren[count].style.background = "#DCDCDC"
                  }
                }
              } else {
                if (item.applyStatus == '1' || item.applyStatus == '0') {
                  calendarTbodyChildrenChildren[count].style.background = "#F7FBFC"
                } else if (item.applyStatus == '2') {
                  calendarTbodyChildrenChildren[count].style.background = "#DCDCDC"
                }
              }
            })
          } else {
            calendarTbodyChildrenChildren[count].style.background = "#FFFFFF"
          }
          if (num > this.calenderDateList.length && date == this.calenderDateList[this.calenderDateList.length - 1].jobDate.substring(8, 10)) {
            changeChk = false
            secondChk = true
          }
        }
      }
    },
    //日期转为字符串formartType='yyyymm'或'yyyymmdd'，
    dateFormart(val, formartType) {
      var y = val.getFullYear();
      var M = val.getMonth() + 1;
      var d = val.getDate();
      if (formartType == 'yyyy-mm-dd') return y + '-' + (M < 10 ? ('0' + M) : M) + '-' + (d < 10 ? ('0' + d) : d);
      if (formartType == 'yyyy/mm/dd') return y + '/' + (M < 10 ? ('0' + M) : M) + '/' + (d < 10 ? ('0' + d) : d);
      if (formartType == 'yyyymm') return y + '' + (M < 10 ? ('0' + M) : M);
    },
    //前月翌月今日综合处理
    monthChange(val) {
      var getEl = this.$refs.elCalendar.$children[0].$children[val]
      //触发调转事件
      getEl.$el.click();
      this.$nextTick(() => {
        let calendarTitle = document.querySelector(
          ".i0020Class .el-calendar__header .el-calendar__title"
        );
        var monthStr = calendarTitle.innerHTML
        if (monthStr.substring(15, 16) === '0' || monthStr.substring(15, 16) === '1' || monthStr.substring(15, 16) === '2') {
          this.selectedMonth = monthStr.substring(7, 11) + monthStr.substring(14, 16)
        } else {
          this.selectedMonth = monthStr.substring(7, 11) + '0' + monthStr.substring(14, 15)
        }
        //刷新数据
        this.query()
        if (document.querySelector(".is-selected") !== null) {
          document.querySelector(".is-selected").classList.remove('is-selected');
        }

      })
    },
    //前月
    preMonthClick() {
      if (this.changedCheck) {
        this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(() => {
          this.isEditMode = false
          this.showDetail = false
          this.changedCheck = false
          this.editChk = true
          this.noteChk = true
          this.monthChange(0)
        }).catch(() => {
          // いいえ
        })
      } else {
        this.isEditMode = false
        this.showDetail = false
        this.changedCheck = false
        this.editChk = true
        this.noteChk = true
        this.monthChange(0)
      }
    },
    //今日
    todayClick() {
      if (this.changedCheck) {
        this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(() => {
          this.isEditMode = false
          this.showDetail = false
          this.changedCheck = false
          this.editChk = true
          this.noteChk = true
          this.monthChange(1)
        }).catch(() => {
          // いいえ
        })
      } else {
        this.isEditMode = false
        this.showDetail = false
        this.changedCheck = false
        this.editChk = true
        this.noteChk = true
        this.monthChange(1)
      }
    },
    //翌月
    nextMonthClick() {
      if (this.changedCheck) {
        this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(() => {
          this.isEditMode = false
          this.showDetail = false
          this.changedCheck = false
          this.editChk = true
          this.noteChk = true
          this.monthChange(2)
        }).catch(() => {
          // いいえ
        })
      } else {
        this.isEditMode = false
        this.showDetail = false
        this.changedCheck = false
        this.editChk = true
        this.noteChk = true
        this.monthChange(2)
      }
    },
    async save_btn() {
      var params = []
      this.calenderDateList.forEach((item) => {
        if (item.changeData) {
          var startTime = item.applyStatus == '1' ? item.startTime : ''
          var endTime = item.applyStatus == '1' ? item.endTime : ''
          var param = {
            "fieldCD": this.$route.query.fieldCd,
            "recruitNo": this.$route.query.recruitNo,
            "jobApplyStaffCode": this.login_userCd,
            "jobDate": item.jobDate,
            "applyStatus": item.applyStatus,
            "startWorkTime": startTime,
            "endWorkTime": endTime,
            "note": item.note,
            "updateDate": item.updateDate.replaceAll('-', '/')
          }
          params.push(param)
        }
      })
      if (params.length == 0) {
        return
      }
      var dateList = []
      var thisMonth = this.selectedMonth.replaceAll('/', '').substring(0, 6)
      // 検索処理
      await amsApi.i_0017_search(thisMonth, this.login_userCd).then(res => {
        //更新基本list
        dateList = JSON.parse(JSON.stringify(res.items.jobIntroInfoList));
      })
      for (var i = 0; i < params.length; i++) {
        if (params[i].startWorkTime && !params[i].endWorkTime) {
          this.$message.error({ message: this.$t('COMMON.MSG_SHIFT_APPLY_END_TIME_VALIDITY'), showClose: true });
          return
        } else if (!params[i].startWorkTime && params[i].endWorkTime) {
          this.$message.error({ message: this.$t('COMMON.MSG_SHIFT_APPLY_START_TIME_VALIDITY'), showClose: true });
          return
        } else if (params[i].startWorkTime && params[i].endWorkTime) {
          if (params[i].startWorkTime.replace(':', '') >= params[i].endWorkTime.replace(':', '')) {
            this.$message.error({ message: this.$t('COMMON.MSG_SHIFT_APPLY_PERIOD_VALIDITY'), showClose: true });
            return
          }
        }
        for (var o = 0; o < dateList.length; o++) {
          if (dateList[o].fieldCode && params[i].jobDate == dateList[o].date) {
            if (this.$route.query.fieldCd != dateList[o].fieldCode) {
              this.$message.error({ message: this.$t('COMMON.MSG_JOB_DATE_ALREADY_APPLY').replaceAll("{1}", params[i].jobDate), showClose: true });
              return
            }
          }
        }
      }
      // 保存处理
      this.$confirm(this.$t('COMMON.MSG_SAVE'), { // 保存します。よろしいでしょうか。
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
        center: true
      }).then(() => {
        // 更新処理
        amsApi.i_0017_apply_update(params).then(res => {
          if (res.code === 202) {//更新成功
            this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
            this.updateList = undefined;
            this.updateList = new Array();
            this.isEditMode = false
            this.firstEditClickFlg = true
            this.passedDateFlg = false
            this.query()
          } else if (res.code === 308) {//shift lock error
            setTimeout(() => {
              this.$confirm(this.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
                confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
                cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
                center: true
              }).then(() => {
                this.query();
              }).catch(() => {
              })
            }, 500)
          } else if (res.code === 311) {
            this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
          }
        })
      }).catch(() => {
        // いいえ
      })
    },
    //日期单元格点击事件。  参数空的场合，直接使用this.selectedDay
    dateCellClick(date) {
      var selectedCellDay
      if (date !== '') {
        selectedCellDay = date.day.replace(/-/g, '/')
        this.showMonth = new Date(selectedCellDay)
      } else {
        return
      }
      var thisDay = date.day.replace(/-/g, '/')
      //从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(item => item.jobDate === thisDay)
      if (Index !== -1) {
        var applyStatus = this.calenderDateList[Index].applyStatus
        if (applyStatus === '1') {
          if (this.isEditMode) {
            this.editChk = false
            this.noteChk = false
          }
          this.workDateStart = this.calenderDateList[Index].startTime
          this.workDateEnd = this.calenderDateList[Index].endTime
          this.note = this.calenderDateList[Index].note
        } else if (applyStatus === '0') {
          if (this.isEditMode) {
            this.editChk = true
            this.noteChk = false
          }
          this.workDateStart = ''
          this.workDateEnd = ''
          this.note = this.calenderDateList[Index].note
        } else if (applyStatus === '2') {
          if (this.isEditMode) {
            this.editChk = true
            this.noteChk = true
          }
          this.workDateStart = ''
          this.workDateEnd = ''
          this.note = ''
        } else if (applyStatus === '3') {
          if (this.isEditMode) {
            this.editChk = true
            this.noteChk = true
          }
          this.workDateStart = this.calenderDateList[Index].startTime
          this.workDateEnd = this.calenderDateList[Index].endTime
          this.note = this.calenderDateList[Index].note
        }
      } else {
        if (this.isEditMode) {
          this.editChk = true
          this.noteChk = true
        }
        this.workDateStart = ''
        this.workDateEnd = ''
        this.note = ''
      }
    },
    //单元格内容表示
    calendarCellcharacters(in_date) {
      var thisDay = in_date.day.replace(/-/g, '/')
      var ret = ''
      ////从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(item => item.jobDate === thisDay)
      if (Index !== -1) {
        var applyStatus = this.calenderDateList[Index].applyStatus
        if (applyStatus === '1' || applyStatus === '3') {
          ret = this.icon_maru
        } else if (applyStatus === '0') {
          ret = this.icon_corss
        } else {
          ret = ''
        }
      } else {
        ret = ''
      }
      return ret
    },
    //タッチstart
    touchStart(in_date) {
      this.showDetail = true
      var date = new Date(in_date.day)
      var weekDay = this.weekStr[date.getDay()]
      this.detailDate = this.dateFormart(date, 'yyyy/mm/dd') + '(' + weekDay + ')'
      this.longPress = false
      clearTimeout(this.loop); //再次清空定时器，防止重复注册定时器
      this.loop = setTimeout(() => {
        this.longPress = true
      }, 500);
    },
    //タッチend
    touchEnd(in_date) {
      clearTimeout(this.loop); //清空定时器，防止重复注册定时器
      if (this.touchmoveFlag == false) {
        if (this.longPress) {
          this.isEditMode = true
        }
        this.longPress = false
        if (this.isEditMode) {
          this.dateCellClick(in_date)
          if (this.detailDate != this.detailDateChk) {
            this.detailDateChk = this.detailDate
            return
          } else {
            this.statusChange(in_date)
          }
        }
      }
      this.touchmoveFlag = false;
    },
    //タッチmove
    touchMove() {
      this.touchmoveFlag = true;
    },
    statusChange(date) {
      if (!this.isEditMode) {
        return
      }
      if (this.detailDate != this.detailDateChk) {
        return
      }
      var thisDay = date.day.replace(/-/g, '/')
      ////从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(item => item.jobDate === thisDay)
      if (Index !== -1) {
        this.changedCheck = true
        var applyStatus = this.calenderDateList[Index].applyStatus
        if (applyStatus === '1') {
          this.calenderDateList[Index].startTime = ''
          this.calenderDateList[Index].endTime = ''
          this.calenderDateList[Index].applyStatus = '0'
          this.calenderDateList[Index].changeData = true
          this.workDateStart = ''
          this.workDateEnd = ''
          this.editChk = true
          this.noteChk = false
        } else if (applyStatus === '0') {
          this.calenderDateList[Index].applyStatus = '1'
          this.calenderDateList[Index].changeData = true
          this.editChk = false
          this.noteChk = false
        }
      }
    },
    //calendar2时间入力失去焦点事件
    cal2_inputBlur() {
      if (this.isEditMode == false) return
      var thisDay = this.detailDate.substring(0, 10).replace(/-/g, '/')
      ////从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(item => item.jobDate === thisDay)
      if (Index !== -1) {
        this.calenderDateList[Index].startTime = this.workDateStart
        this.calenderDateList[Index].endTime = this.workDateEnd
        this.calenderDateList[Index].note = this.note
        this.calenderDateList[Index].changeData = true
      }
    },
    //calendar1时间入力失去焦点事件
    cal1_inputBlur(val) {
      if (this.isEditMode == false) return
      this.changedCheck = true
      var retValue = ''
      if (val) {
        retValue = utilsApi.timeFormatter(val)
      } else {
        retValue = ''
      }
      return retValue
    },
    // 时间入力check
    timeInputCheck(val) {
      if (!val) {
        return
      }
      var reg = /^\d*(\:?\d{0,2})/g
      var matchResult = val.match(reg)
      if (matchResult === null) {
        return null
      } else {
        return matchResult[0]
      }
    },
    //cal2的cell样式
    HeaderClass({ row, rowIndex }) {
      return 'HeaderClass'
    },
    //cal2的head样式
    IsCellClass({ row, rowIndex }) {
      return 'IsCellClass'
    },
  },
  computed: {
    selectedMonthStr() {
      return this.selectedMonth.replaceAll('/', '').substring(0, 4) + '年' + this.selectedMonth.replaceAll('/', '').substring(4, 6) + '月'
    }
  },
};
</script>
<style>
.i0020Class * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.i0020Class .is-selected {
  color: #000000;
  font-weight: bold;
}
.i0020Class .el-calendar-table .el-calendar-day {
  height: 50px;
  padding: 0px;
}
.i0020Class .el-calendar__body {
  padding-bottom: 10px;
  padding: 0 0 0 0;
}
/* 本月以外の日付はクリック無効 */
.i0020Class .el-calendar-table td.next {
  pointer-events: none;
}
.i0020Class .el-calendar-table td.prev {
  pointer-events: none;
}
/* copy paste 禁止 */
.i0020Class .calenderMode1-calendar * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.i0020Class .el-main {
  height: 100%;
  padding: 0 !important;
  overflow: hidden;
  position: relative;
}

.i0020Class .el-calendar-table thead th {
  background-color: #3f50ec27;
  border: 1px solid #e2e3e4;
  padding-top: 7px;
  padding-bottom: 7px;
}
/*input输入框*/
.i0020Class .card-css-input {
  width: 100%;
  padding: 0px 0px 0px 0px;
}
/* 隐藏calendar的日期头和按钮部分 */
.i0020Class .el-calendar .el-calendar__header {
  display: none;
}
/* radio间距 */
.i0020Class .el-radio {
  margin-right: 5px;
}
.i0020Class .calenderMode2-calendar .cell {
  padding-left: 4px;
  padding-right: 4px;
}
.i0020Class .calenderMode2-calendar .el-input__inner {
  padding-left: 7px;
  padding-right: 4px;
}
.i0020Class .calenderMode2-calendar .el-table td,
.el-table th {
  text-align: center;
}

.i0020Class .opacity {
  position: absolute;
  width: 100px;
  -khtml-opacity: 0.2;
  -moz-opacity: 0.2;
  filter: alpha(opacity=20);
  filter: 'alpha(opacity=20)';
  opacity: 0.2;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=20);
  z-index: 200; /*兼容ie8及以下*/
}
.i0020Class .HeaderClass .cell {
  white-space: pre-line;
}
.i0020Class .IsCellClass .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.i0020Class table.detailTable {
  width: 100%;
  border: 2px solid #444;
  border-spacing: 0;
}
.i0020Class table.detailTable tr,
.i0020Class table.detailTable th {
  border-bottom: 1px solid #444;
}
.i0020Class table.detailTable td,
.i0020Class table.detailTable th {
  border-right: 1px solid #444;
  border-bottom: 1px solid #444;
  padding: 5px;
}
.i0020Class table.detailTable tr td:last-child {
  border-right: 0;
}
.i0020Class table.detailTable tr:last-child td {
  border-bottom: 0;
}
.i0020Class .el-table th {
  background-color: #23b2e8;
  color: #ffffff;
}
.input_textarea_i0020 {
  width: 93.5%;
  min-width: 40%;
  float: left;
  color: #000000;
  vertical-align: top;
}
/* 表格边框、字体样式 */
.i0020-table {
  border-collapse: collapse;
  width: 100%;
}
/* 表格边框颜色 */
.i0020-table,
.i0020-table tr td {
  border: 1px solid #ccc;
}
.i0020-form-value,
.i0020-form-value tr td {
  padding-right: 0 !important;
}
/* 表格内边距 */
.i0020-table td {
  padding: 5px 8px;
}
/* 表格第一列背景色、宽度、文字居右 */
.i0020-form-label {
  text-align: right;
  width: 110px;
  background: #d2eef8;
}
/* 表格第二列背景色 */
.i0020-form-value {
  background: #fafafa;
}
.i0020-form-value .el-button--small,
.el-button--small.is-round {
  padding-left: 9px;
  padding-right: 9px;
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0020.vue